<script>
import { Bar } from "vue-chartjs";
export default {
  extends: Bar,
  props: ['data'],
  data() {
    return {
      all_months: [  this.$t('statistics.january'), 
                this.$t('statistics.february'), 
                this.$t('statistics.march'), 
                this.$t('statistics.april'), 
                this.$t('statistics.may'), 
                this.$t('statistics.june'), 
                this.$t('statistics.july'), 
                this.$t('statistics.august'), 
                this.$t('statistics.september'), 
                this.$t('statistics.october'), 
                this.$t('statistics.november'), 
                this.$t('statistics.december') ]
    }
  },
  methods: {
    labels(){
      var labels = []
      var today = new Date();
      for(var i = 14; i >= 0; i -= 1) {
        var d = new Date(today.getFullYear(), today.getMonth() - i, 1);
        labels.push((d.getMonth()+1).toString() + "/" + (d.getFullYear()).toString())
      }
      return labels;
    }
  },
  mounted() {
    var dis = this
    this.renderChart(
      {
        //labels: [ "Január", "Február", "Marec", "Apríl", "Máj", "Jún", "Júl", "August", "September", "Október", "November", "December" ],
        labels: this.labels(),
        datasets: [
          {
            data: this.data,
            backgroundColor: '#007bff',
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: '#FBBF24',
          }
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        legend: {display: false},
        tooltips: {
          displayColors: false,
          callbacks: {
              label: function(t, d) {
                var lab = t.xLabel.substr(0, t.xLabel.indexOf('/')); 
                var xLabel =  dis.all_months[parseInt(lab) - 1]
                if(t.yLabel > 4)
                    var yLabel = t.yLabel + dis.$t('statistics.graph_text1');
                else if(t.yLabel == 1)
                    var yLabel = t.yLabel + dis.$t('statistics.graph_text2');
                else
                    var yLabel = t.yLabel + dis.$t('statistics.graph_text3');
                return xLabel + " - " + yLabel;
              },
              title: function(t, d) {
                return ""
              }
          }
        },
        scales: {
          xAxes: [{
            barPercentage: 0.15,
            ticks: {
                fontColor: "#9CA3AF",
            },
            gridLines: {
              display: false,
            }
          }],
          yAxes: [{
            scaleLabel: { color: "#9CA3AF" },
            gridLines: {
              drawBorder: false,
              tickMarkLength: false,
              borderDash: [3, 3],
              color: "#BDBDBD"
            },
            ticks: {
                precision:0,
                fontColor: "#9CA3AF",
                beginAtZero: true,
                callback: function(value, index, values) {
                  if(parseInt(value) >= 1000){
                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " ";
                  } else {
                    return value + " ";
                  }
                }
            },
          }],
        }
      }
    );
  }
};
</script>